// extracted by mini-css-extract-plugin
export default {"header-container":"formHeader_header-container__KJyrq","header-title":"formHeader_header-title__O2+MD"};